import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UniqueIDService {
    private index: number = 1;

    generateID(): number {
        const id: number = this.index;

        this.index++;

        return id;
    }
}
